import React from 'react';
import StepBox from './StepBox';
import Step1 from '../assets/iconImages/Step1.png';
import Step2 from '../assets/iconImages/Step2.png';
import Step3 from '../assets/iconImages/Step3.png';
import Arrow2 from '../assets/icons/Arrow2';
import Button from './Button';


const StepsSection = () => {
  return (
    <div className="steps-section" style={styles.stepsSection}>
      <h2 style={styles.heading}>Kako funkcioniše SmartPart</h2>

      <div style={styles.stepsContainer}>
        <StepBox
          icon={Step1}
          title="1. Postavi zahtev za deo koji tražiš"
          description="Unesi podatke o auto delu koji ti je potreban - model vozila, godina proizvodnje i detalji. Naša platforma omogućava lako kreiranje zahteva u samo nekoliko klikova!"
        />
        <Arrow2  />

        <StepBox
          icon={Step2}
          title="2. Oglasi zahtev svim prodavcima"
          description="Prodavci se takmiče da ti ponude najbolje cene i uslove. Sve ponude su pregledne, a ti biraš onu koja ti najviše odgovara. Za 24h imaćeš sve ponude prodavca na jednom mestu!"
        />
        <Arrow2  />

        <StepBox
          icon={Step3}
          title="3. Izaberi najbolju ponudu za sebe"
          description="Pregledaj sve pristigle ponude i odluči se za onu koja ti najviše odgovara - bilo da je to najbolja cena, najbrža isporuka, ili prodavac sa najboljim ocenama. Brzo, lako i efikasno!"
        />
      </div>

      <div className="steps action" style={styles.action}>
        <p className="cta-text" style={styles.ctatext}>
          Tvoj izbor je jednostavan zahvaljujući preglednoj platformi SmartPart <br /> koja sve detalje stavlja na dohvat ruke!
        </p>
        <Button
  width={350} 
  height={72} 
  borderColor="yellow" 
  backgroundColor="#d3e205" 
  text="Isprobaj platformu" 
/>
      </div>
    </div>
  );
};

export default StepsSection;

const styles = {
  heading: {
    fontSize: '48px',
    fontWeight: 700,
    color: '#d3e205',
    marginBottom: 16,
    lineHeight: '42px',
  },
  stepsSection: {
    padding: '40px',
    backgroundColor: 'rgb(23, 23, 24)',
    textAlign: 'center',
     marginBottom: '100px'
  },
  stepsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    flexWrap: 'nowrap',
    marginTop: '50px',
    marginBottom: '100px',
  },
  action: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
  },

  ctatext: {
    color: 'rgba(255, 255, 255, 0.87)',
    fontSize: '40px',
    fontWeight: 400,
    letterSpacing: '0px',
    textAlign: 'center',
    lineHeight: '52px',
  },
  

};
